import React, { useState, useEffect, useMemo, useLayoutEffect } from "react";
import AddEditFormComponent from "../../ReUseComponents/AddEditFormComponent";
import { FloatingLabel, Form } from "react-bootstrap";
import Select from "react-select";
import * as swal from "../../Consturl/SwalAlert";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { loadUserRegion } from "../../../redux/action";
import "../../../styles/VhdBranch.scss";
import { SBSaveUpdateBtn } from "../../SbButtons/SbAddBtn";
import SbCancelBtn from "../../SbButtons/SbCancelBtn";
import { enableYesNoOptions } from "../../DropdownsData";

export default function AddBranchModel(props) {
  let dispatch = useDispatch();

  const { userRegionResult } = useSelector((state) => state.data);
  const [countryList, setCountryList] = useState([]);
  const [zoneList, setZoneList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [country, setCountry] = useState({ value: null, label: "" });
  const [zone, setZone] = useState({ value: null, label: "" });
  const [state, setState] = useState({ value: null, label: "" });
  const [city, setCity] = useState({ value: null, label: "" });

  const [branchData, setBranchdata] = useState({
    branchCode: "",
    branchName: "",
    contactName: "",
    contactNumber: "",
    contactEmail: "",
    countryId: "",
    zoneId: "",
    stateId: "",
    location: "",
    enableStatus: 1,
  });

  const {
    branchName,
    branchCode,
    contactName,
    contactNumber,
    contactEmail,
    countryId,
    zoneId,
    stateId,
    location,
    enableStatus,
  } = branchData;

  const [fieldReq, setFieldReq] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    alertType: null,
    message: null,
  });

  useLayoutEffect(() => {
    dispatch(loadUserRegion());
  }, []);

  useEffect(() => {
    if (Object.keys(userRegionResult).length > 0) {
      setCountryList(
        userRegionResult?.allCountry.map((data) => {
          return {
            value: data.countryID,
            label: data.countryName,
          };
        }) ?? []
      );
      setZoneList(
        userRegionResult?.allZones.map((data) => {
          return { value: data.zoneId, label: data.zoneName };
        }) ?? []
      );
      setStateList(
        userRegionResult?.allStates.map((data) => {
          return { value: data.stateId, label: data.stateName };
        }) ?? []
      );
    }
  }, [userRegionResult]);

  const handleInputData = (e) => {
    const { name, value } = e.target;
    setBranchdata({ ...branchData, [name]: value });
  };

  const handleSelectChange = (data, type) => {
    if (type === "country") {
      setCountry(data);
      branchData.countryId = data.value;
    }
  };

  const addBranchData = () => {
    console.log("ADD-DATA:", "api data come");
  };

  const closeModel = () => {
    props.handleClose();
    props.setBranchID(null);
  };

  return (
    <div>
      <AddEditFormComponent
        handleClose={closeModel}
        formName={props.branchID ? "Edit Branch" : "Add Branch"}
        formSubTitle={
          props.branchID
            ? "Edit the branch details."
            : "Please add the branch details."
        }
        sidebarItems={props.branchID ? ["Edit Branch"] : ["Add Branch"]}
        childrens={
          <>
            <form onSubmit={addBranchData}>
              <div className="add-branch-to-vhd">
                <div className="add-branch-details">
                  <div className="row">
                    <div className="col my-3">
                      <FloatingLabel
                        label="Branch Name"
                        className={`${
                          branchName
                            ? "float-input-visible"
                            : "float-hidden float-input"
                        }`}
                      >
                        <input
                          type="text"
                          autoComplete="off"
                          className="form-control form add-input"
                          placeholder="Branch"
                          value={branchName}
                          onChange={(e) => handleInputData(e)}
                          required
                        />
                      </FloatingLabel>

                      {/* {fieldReq && branchName == "" ? (
                        <small
                          id={`Error${alertMessage.alertType}`}
                          className="form-text text-muted "
                        >
                          {`${alertMessage.message}`}
                        </small>
                      ) : (
                        ""
                      )} */}
                    </div>
                    <div className="col my-3">
                      <FloatingLabel
                        label="Branch Code"
                        className={`${
                          branchCode
                            ? "float-input-visible"
                            : "float-hidden float-input"
                        }`}
                      >
                        <input
                          type="number"
                          autoComplete="off"
                          className="form-control form add-input"
                          placeholder="Code"
                          value={branchCode}
                          onChange={(e) => handleInputData(e)}
                          required
                        />
                      </FloatingLabel>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col my-3">
                      <FloatingLabel
                        label="Contact Name"
                        className={`${
                          contactName
                            ? "float-input-visible"
                            : "float-hidden float-input"
                        }`}
                      >
                        <input
                          type="text"
                          autoComplete="off"
                          className="form-control form add-input"
                          placeholder="Contact Name"
                          value={contactName}
                          onChange={(e) => handleInputData(e)}
                          required
                        />
                      </FloatingLabel>
                    </div>
                    <div className="col my-3">
                      <FloatingLabel
                        label="Contact Number"
                        className={`${
                          contactNumber
                            ? "float-input-visible"
                            : "float-hidden float-input"
                        }`}
                      >
                        <input
                          type="number"
                          autoComplete="off"
                          className="form-control form add-input"
                          placeholder="Contact Number"
                          maxLength={10}
                          value={contactNumber}
                          onChange={(e) => handleInputData(e)}
                          required
                        />
                      </FloatingLabel>
                    </div>
                    <div className="col my-3">
                      <FloatingLabel
                        label="Contact Email"
                        className={`${
                          contactEmail
                            ? "float-input-visible"
                            : "float-hidden float-input"
                        }`}
                      >
                        <input
                          type="email"
                          autoComplete="off"
                          className="form-control form add-input"
                          placeholder="Contact Email"
                          value={contactEmail}
                          onChange={(e) => handleInputData(e)}
                          required
                        />
                      </FloatingLabel>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col my-3">
                      <FloatingLabel
                        label="Select Country"
                        className={`${
                          country.value !== null
                            ? "float-visible-select"
                            : "float-hidden float-select"
                        }`}
                      >
                        <Select
                          className="react-select-container-list model-select"
                          classNamePrefix="react-select-list"
                          name="country"
                          options={countryList}
                          placeholder="Select Country"
                          value={country.value ? country : ""}
                          onInputChange={countryList.label}
                          onChange={(data) =>
                            handleSelectChange(data, "country")
                          }
                          isSearchable={true}
                        />
                      </FloatingLabel>
                    </div>
                    <div className="col my-3">
                      <FloatingLabel
                        label="Select Zone"
                        className={`${
                          zone.value !== null
                            ? "float-visible-select"
                            : "float-hidden float-select"
                        }`}
                      >
                        <Select
                          className="react-select-container-list model-select"
                          classNamePrefix="react-select-list"
                          options={zoneList}
                          placeholder="Select Zone"
                          value={zone.value ? zone : ""}
                          onInputChange={zoneList.label}
                          onChange={(data) => handleSelectChange(data, "zone")}
                          isSearchable={true}
                        />
                      </FloatingLabel>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col my-3">
                      <FloatingLabel
                        label="Select State"
                        className={`${
                          state.value !== null
                            ? "float-visible-select"
                            : "float-hidden float-select"
                        }`}
                      >
                        <Select
                          className="react-select-container-list model-select"
                          classNamePrefix="react-select-list"
                          options={stateList}
                          placeholder="Select State"
                          value={state.value ? state : ""}
                          onInputChange={stateList.label}
                          onChange={(data) => handleSelectChange(data, "state")}
                          isSearchable={true}
                        />
                      </FloatingLabel>
                    </div>
                    <div className="col my-3">
                      <FloatingLabel
                        label="Select City"
                        className={`${
                          city
                            ? "float-visible-select"
                            : "float-hidden float-select"
                        }`}
                      >
                        <Select
                          className="react-select-container-list model-select"
                          classNamePrefix="react-select-list"
                          options={stateList}
                          placeholder="Select City"
                          value={city.value && state}
                          onInputChange={stateList.label}
                          onChange={(data) => handleSelectChange(data, "state")}
                          isSearchable={true}
                        />
                      </FloatingLabel>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col my-3">
                      <FloatingLabel
                        label="Location *"
                        className={`${
                          location
                            ? "float-input-visible"
                            : "float-hidden float-input"
                        }`}
                      >
                        <textarea
                          rows="3"
                          cols="20"
                          name="locationtxt"
                          wrap="hard"
                          className="form-control form-textarea add-user-input"
                          id="exampleFormControlInput1"
                          placeholder="Location (Please click the icon for location)"
                          value={location}
                          readOnly={true}
                          // required
                          // onChange={(e) => setLocation(e)}
                        />
                      </FloatingLabel>
                    </div>
                  </div>
                </div>
                <div className="row dflex-j-between">
                  {props.branchID && (
                    <div className="dflex-j-start">
                      <div className="mb-2">Enable</div>&nbsp;&nbsp;&nbsp;
                      {enableYesNoOptions.map((item, i) => (
                        <div key={i}>
                          <Form.Check
                            inline
                            label={item?.label}
                            value={item?.value}
                            name="enableStatus"
                            type="radio"
                            id={`inlineradio-enableStatus-${i}`}
                            onChange={handleInputData}
                            checked={item?.value == enableStatus ? true : false}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                  <div className="add-page-save-cancel">
                    <SBSaveUpdateBtn btnName="Save" />
                    <SbCancelBtn btnName="Cancel" onClickEffect={closeModel} />
                  </div>
                </div>
              </div>
            </form>
          </>
        }
      />
    </div>
  );
}
